import React from 'react';
import { Container } from '@mui/material';
import { useTitle } from 'react-use';
import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@mui/material';
import { t } from '@lingui/core/macro';
import ActiveCuttings from '../timber/components/cutting/CuttingList/ActiveCuttings.tsx';

const ReportsPage = () => {
  useTitle(t`Reports`);

  return (
    <Container maxWidth="lg" data-testid="Reports-page">
      <Box sx={{ pt: 2 }} data-testid="Reports-list-title-wrapper">
        <Typography
          variant="h4"
          component="h1"
          data-testid="Reports-list-title"
        >
          <Trans>Reports</Trans>
        </Typography>
      </Box>
      <ActiveCuttings />
    </Container>
  );
};

export default ReportsPage;
